export { default as Table } from './Table';
export { default as THead } from './THead';
export { default as TFoot } from './TFoot';
export { default as TBody } from './TBody';
export { default as TableRow } from './TableRow';
export { default as TD } from './TD';
export { default as TH } from './TH';
export { default as TableCell } from './TableCell';
